// extracted by mini-css-extract-plugin
export default {"back":"Background_back__B67xf","middle":"Background_middle__bribq","front":"Background_front__d2qeD"};